import { constructQueryParamName } from '../util/search';

export const categoryPageConfigs = {
  'sofas-armchairs': {
    slug: 'sofas-armchairs',
    categoryId: 'sofas-armchairs',
    metaTitle: 'Second-Hand Sofas & Seating UK | Used Sofas for Sale | Refurnish',
    metaDescription:
      'Shop second-hand sofas and seating across the UK. Browse affordable used armchairs, preloved corner sofas, accent chairs and living room furniture on Refurnish.',
    heading: 'Second-Hand Sofas & Seating',
    intro:
      'Browse second-hand sofas and seating from sellers across the UK. Find preloved armchairs, statement chairs and affordable living room furniture that gives great pieces a second life.',
  },
  tables: {
    slug: 'tables',
    categoryId: 'tables',
    metaTitle: 'Used Tables and Dining for Sale UK | Second-Hand Dining & Coffee Tables | Refurnish',
    metaDescription:
      'Discover used tables for sale in the UK, including dining table sets, coffee tables and side tables. Shop second-hand tables and dining and save with Refurnish.',
    heading: 'Used Tables and Dining for Sale',
    intro:
      'Discover second-hand tables for every room. Whether you need a compact side table or a full dining set, find quality preloved pieces from sellers across the UK.',
  },
  'storage-furniture': {
    slug: 'storage-furniture',
    categoryId: 'storage-furniture',
    metaTitle: 'Used Storage Furniture UK | Second-Hand Wardrobes, Drawers & Shelves | Refurnish',
    metaDescription:
      'Buy second-hand storage furniture in the UK, including wardrobes, chests of drawers, shelving and cabinets. Find used storage solutions on Refurnish.',
    heading: 'Used Storage Furniture',
    intro:
      'Find second-hand storage furniture that helps you organise every room. Browse wardrobes, shelving, sideboards and drawers from UK sellers looking to give great furniture a new home.',
  },
  lighting: {
    slug: 'lighting',
    categoryId: 'lighting',
    metaTitle: 'Second-Hand Lighting UK | Used Lamps & Home Lighting | Refurnish',
    metaDescription:
      'Shop second-hand lighting in the UK, from table lamps and floor lamps to statement lighting and everyday home decor. Find used lighting on Refurnish.',
    heading: 'Second-Hand Lighting',
    intro:
      'Browse second-hand lighting for bedrooms, living rooms, offices and more. Discover used table lamps, floor lamps and stylish home lighting from sellers across the UK.',
  },
  'mirrors-decor': {
    slug: 'mirrors-decor',
    categoryId: 'mirrors-decor',
    metaTitle: 'Used Mirrors & Decor UK | Second-Hand Home Decor | Refurnish',
    metaDescription:
      'Discover second-hand mirrors and home decor in the UK. Shop used wall mirrors, decorative accessories and preloved home styling pieces on Refurnish.',
    heading: 'Used Mirrors & Decor',
    intro:
      'Shop second-hand mirrors and decor that add character to your space. From statement mirrors to decorative home accessories, find unique preloved pieces from UK sellers.',
  },
  'tv-monitor': {
    slug: 'tv-monitor',
    categoryId: 'tv-monitor',
    metaTitle: 'Second-Hand TVs & Monitors UK | Used Screens for Sale | Refurnish',
    metaDescription:
      'Browse second-hand TVs and monitors in the UK. Find affordable used screens, home office monitors and preloved tech furniture pairings on Refurnish.',
    heading: 'Second-Hand TVs & Monitors',
    intro:
      'Explore second-hand TVs and monitors from UK sellers. Whether you need a screen for work, study or entertainment, discover used options that are affordable and practical.',
  },
  rugs: {
    slug: 'rugs',
    categoryId: 'rugs',
    metaTitle: 'Used Rugs UK | Second-Hand Rugs & Carpets | Refurnish',
    metaDescription:
      'Shop second-hand rugs in the UK, including living room rugs, hallway runners and decorative floor coverings. Discover used rugs and carpets on Refurnish.',
    heading: 'Used Rugs',
    intro:
      'Browse second-hand rugs that bring warmth, texture and colour to your home. Find used area rugs, runners and decorative floor pieces from sellers across the UK.',
  },
  'beds-mattresses': {
    slug: 'beds-mattresses',
    categoryId: 'beds-mattresses',
    metaTitle: 'Second-Hand Beds & Mattresses UK | Used Beds for Sale | Refurnish',
    metaDescription:
      'Shop second-hand beds and mattresses across the UK. Browse affordable used bed frames, double beds, single beds and like-new mattresses on Refurnish.',
    heading: 'Second-Hand Beds & Mattresses',
    intro:
      'Browse second-hand beds and mattresses from sellers across the UK. From single beds and bunk beds to double and king-size frames, find quality preloved beds at great prices.',
  },
  'outdoor-garden': {
    slug: 'outdoor-garden',
    categoryId: 'outdoor-garden',
    metaTitle: 'Used Outdoor & Garden Furniture UK | Second-Hand Garden Furniture | Refurnish',
    metaDescription:
      'Shop second-hand outdoor and garden furniture in the UK. Browse used patio furniture, garden seating and preloved outdoor decor on Refurnish.',
    heading: 'Used Outdoor & Garden Furniture',
    intro:
      'Browse second-hand outdoor and garden furniture for patios, balconies and green spaces. Find used seating, tables and decorative garden pieces from across the UK.',
  },
  'kids-nursery': {
    slug: 'kids-nursery',
    categoryId: 'kids-nursery',
    metaTitle: 'Second-Hand Kids & Nursery Furniture UK | Used Nursery Furniture | Refurnish',
    metaDescription:
      'Find second-hand kids and nursery furniture in the UK, including nursery storage, seating and practical preloved family furniture on Refurnish.',
    heading: 'Second-Hand Kids & Nursery Furniture',
    intro:
      'Shop second-hand kids and nursery furniture that is practical, affordable and ready for a new family. Browse preloved children\'s furniture from sellers across the UK.',
  },
  'office-study': {
    slug: 'office-study',
    categoryId: 'office-study',
    metaTitle: 'Used Office & Study Furniture UK | Second-Hand Home Office Furniture | Refurnish',
    metaDescription:
      'Browse second-hand office and study furniture in the UK, including desks, office chairs and storage. Shop used home office furniture on Refurnish.',
    heading: 'Used Office & Study Furniture',
    intro:
      'Find second-hand office and study furniture for home working, student spaces and creative setups. Shop used desks, storage and practical work-from-home pieces across the UK.',
  },
  'other-unique-finds': {
    slug: 'other-unique-finds',
    categoryId: 'other-unique-finds',
    metaTitle: 'Unique Second-Hand Furniture Finds UK | Vintage & One-Off Pieces | Refurnish',
    metaDescription:
      'Discover unique second-hand furniture finds in the UK, from unusual decor to one-off preloved pieces. Shop standout used furniture on Refurnish.',
    heading: 'Unique Second-Hand Finds',
    intro:
      'Explore unique second-hand furniture and home decor that stands out from the ordinary. From unusual statement pieces to one-off finds, discover preloved gems from UK sellers.',
  },
};

export const getCategoryPageConfig = categorySlug =>
  categorySlug ? categoryPageConfigs[categorySlug] || null : null;

export const getCategorySlugByCategoryId = categoryId => {
  if (!categoryId) {
    return null;
  }

  const configs = Object.values(categoryPageConfigs);
  const matchingConfig = configs.find(config => {
    return config.categoryId === categoryId || config.fallbackCategoryId === categoryId;
  });

  return matchingConfig?.slug || null;
};

const resolveCategoryId = (categoryPageConfig, listingCategories = []) => {
  if (!categoryPageConfig) {
    return null;
  }

  const categoryIds = new Set(listingCategories.map(category => category.id));
  const preferredIds = [categoryPageConfig.categoryId, categoryPageConfig.fallbackCategoryId].filter(
    Boolean
  );
  const matchingId = preferredIds.find(categoryId => categoryIds.has(categoryId));

  return matchingId || categoryPageConfig.categoryId;
};

export const getCategoryPageSearchParams = (
  categorySlug,
  categoryFilterConfig,
  listingCategories = []
) => {
  const categoryPageConfig = getCategoryPageConfig(categorySlug);
  const categoryId = resolveCategoryId(categoryPageConfig, listingCategories);
  const topLevelKey = categoryFilterConfig?.nestedParams?.[0];
  const paramName =
    topLevelKey && categoryFilterConfig?.scope
      ? constructQueryParamName(topLevelKey, categoryFilterConfig.scope)
      : topLevelKey
      ? constructQueryParamName(topLevelKey, 'public')
      : 'pub_categoryLevel1';

  return categoryId ? { [paramName]: categoryId } : {};
};
